import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { ClienteAnaliseFinanceiraAuthGuardService, ClienteAnaliseFinanceiraHttpService } from './services';
import { ClienteAnaliseFinanceira } from './cliente-analise-financeira';

// interface Config {
//     canIniciar: boolean;
//     canCancelarIniciar: boolean;
//     canConcluir: boolean;
//     canCancelarConcluir: boolean;
//     canRevisar: boolean;
// }

@Component({
    selector: 'sgt-cliente-analise-financeira',
    templateUrl: './cliente-analise-financeira.component.html',
    styleUrls: ['./cliente-analise-financeira.component.less']
})
export class ClienteAnaliseFinanceiraComponent implements OnInit {
    // config: Config;
    @Input() cliente: ClienteAnaliseFinanceira;
    @Output() clienteChange = new EventEmitter<ClienteAnaliseFinanceira>();
    isLoading: boolean;

    @Input() idCliente: number;
    @Input() showCliente = true;
    @Input() showRepresentante = true;

    constructor(private messageService: MessageService,
                private clienteAnaliseFinanceiraAuthGuardService: ClienteAnaliseFinanceiraAuthGuardService,
                private clienteAnaliseFinanceiraHttpService: ClienteAnaliseFinanceiraHttpService) { }

    ngOnInit(): void {
        this.load()
            .then(() => {
                // this.setConfig();
            })
            .catch(() => {});
    }

    private load(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.cliente = null;
            this.isLoading = true;
            this.clienteAnaliseFinanceiraHttpService.load(this.idCliente)
                .pipe(
                    take(1)
                )
                .subscribe(
                    cliente => {
                        this.cliente = cliente;
                        this.clienteChange.emit(this.cliente);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        reject();
                    },
                    () => this.isLoading = false
                );
        });
    }

    // private setConfig() {
    //     this.config = {
    //         canIniciar: this.clienteAnaliseFinanceiraAuthGuardService.canIniciar(this.cliente?.statusAnaliseFinanceira),
    //         canCancelarIniciar: this.clienteAnaliseFinanceiraAuthGuardService.canCancelarIniciar(this.cliente?.statusAnaliseFinanceira),
    //         canConcluir: this.clienteAnaliseFinanceiraAuthGuardService.canConcluir(this.cliente?.statusAnaliseFinanceira),
    //         canCancelarConcluir: this.clienteAnaliseFinanceiraAuthGuardService.canCancelarConcluir(this.cliente?.statusAnaliseFinanceira),
    //         canRevisar: this.clienteAnaliseFinanceiraAuthGuardService.canRevisar(this.cliente?.statusAnaliseFinanceira),
    //     };
    // }


}
